import React from "react";
import { Link } from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";
import logofooter from "../images/logoname.jpeg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* LOGO + TEXT */}
        <div className="footer-col">
          <img src={logofooter} className="logo-footer" alt="logo" />
          <p>
            Exporting premium quality Fruits, Vegetables and Spices from India
            to the world.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/products">Products</Link>
            </li>
            <li>
              <Link to="/process">Our Process</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>

        {/* PRODUCTS */}
        <div className="footer-col">
          <h3>Our Products</h3>
          <ul>
            <li>
              <Link to="/products/fruits">Fruits</Link>
            </li>
            <li>
              <Link to="/products/vegetables">Vegetables</Link>
            </li>
            <li>
              <Link to="/products/spices">Spices</Link>
            </li>
          </ul>
          <Link to="/developer" className="dev-btn">
            👨‍💻 Developer Contact
          </Link>
        </div>

        {/* CONTACT */}
        <div className="footer-col footer-col-contact">
          <h3>Contact Us</h3>

          <div className="contact-container">
            <div className="contact-itemf">
              <a href="tel:+918497944251">
                <span className="icon">📞</span>
              </a>
              <p>+91 8497944251</p>
            </div>

            <div className="contact-itemf">
              <a href="mailto:giridhar@uniqueglobalexports.com">
                <span className="icon">📧</span>
              </a>
              <p>giridhar@uniqueglobalexports.com</p>
            </div>

            <div className="contact-itemf">
              <span className="icon">📍</span>
              <p>
                1-8-294/4/A/1, Aadarsh Nagar, Metpally,

                Jagityal, Telangana - 505325, India
              </p>
            </div>
          </div>

          <div className="social-icons">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/uniqueglobal_exporters/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://wa.me/918497944251?text=Hello, I am interested in your export products. Could you please share more details about your products and export process?"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
            {/* <FaFacebookF size={40} />

            <a
              href="https://www.instagram.com/uniqueglobal_exporters/"
              target="_blank"
              rel="noopener noreferrer"
              className="whtapp"
            >
              <FaInstagram size={40} />
            </a>

            <FaWhatsapp
              className="whtapp"
              size={40}
              style={{ cursor: "pointer" }}
              onClick={() => {
                const url = `https://wa.me/918497944251?text=Hello, I am interested in your export products. Could you please share more details about your products and export process?`;
                window.open(url, "_blank");
              }}
            /> */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Unique Global Exports. All rights reserved.
      </div>

      <style>{`
          .footer {
                background: linear-gradient(90deg, #064e3b, #065f46, #16a34a);
                color: #e5e7eb;
                padding: 70px 8% 25px;
                font-family: 'Poppins', sans-serif;
              }

              /* GRID */
              .footer-container {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 50px;
              }

              /* LOGO */
              .logo-footer {
                width: 150px;
                margin-bottom: 18px;
                border-radius: 10px;
              }
                .icon {
          cursor: pointer;
        }

              /* TEXT */
              .footer-col p {
                font-size: 14px;
                line-height: 1.7;
                color: #ffffff;
                font-weight: 500;
              }

              /* HEADINGS */
              .footer-col h3 {
                font-size: 16px;
                margin-bottom: 18px;
                color: #ffffff;
                font-weight: 600;
                letter-spacing: 0.5px;
              }

              /* LINKS */
              .footer-col ul {
                list-style: none;
                padding: 0;
              }

              .footer-col ul li {
                margin-bottom: 12px;
              }

              .footer-col ul li a {
                text-decoration: none;
                color: #ffffff;
                font-size: 14px;
                font-weight: 500;
                transition: all 0.25s ease;
              }

              .footer-col ul li a:hover {
                color: #ffffff;
                transform: translateX(4px);
              }

              /* CONTACT FIX (your main issue) */
              .footer-col-contact {
                display: flex;
                flex-direction: column;
                gap: 14px;
                max-width: 260px;
              }

              .contact-container {
                display: flex;
                flex-direction: column;
                gap: 15px;
              }

              .contact-itemf {
                display: grid;
                grid-template-columns: 40px 1fr;
                align-items: start;
                column-gap: 12px;
              }

              .contact-itemf span {
                font-size: 22px;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .contact-itemf p {
                margin: 0;
                text-decoration: none;
                color: inherit;
              }

              .contact-itemf a,
              .contact-itemf a:hover,
              .contact-itemf a:focus,
              .contact-itemf a:active {
                text-decoration: none;
                color: inherit;
              }

              /* SOCIAL ICONS (premium size) */
              .social-icons {
                display: flex;
                gap: 12px;
                margin-top: 18px;
              }

              .social-icons a {
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .social-icons svg {
                width: 44px;
                height: 44px;
                padding: 6px;
                border-radius: 50%;
                /* 🔥 Always white */
                color: #ffffff;

                /* Soft glass background */
                background: rgba(255, 255, 255, 0.08);

                transition: all 0.3s ease;
              }

              /* ✨ Premium hover (no color change, only subtle effect) */
              .social-icons svg:hover {
                background: rgba(255, 255, 255, 0.18);
                transform: translateY(-3px) scale(1.05);
              }
              /* DEV BUTTON (premium glass style) */
              .dev-btn {
                margin-top: 15px;
                display: inline-block;
                padding: 8px 14px;
                border-radius: 999px;
                font-size: 13px;
                color: #fff;
                text-decoration: none;
                background: rgba(255,255,255,0.08);
                backdrop-filter: blur(6px);
                border: 1px solid rgba(255,255,255,0.2);
                transition: 0.3s;
              }

              /* ✨ Hover effect */ 
              .dev-btn:hover { 
              transform: translateY(-2px) scale(1.03); 
              box-shadow: 0 8px 20px rgba(0,0,0,0.25); 
              }

              /* FOOTER BOTTOM */
              .footer-bottom {
                margin-top: 40px;
                text-align: center;
                font-size: 13px;
                color: #feffff;
                border-top: 1px solid rgba(255,255,255,0.15);
                padding-top: 18px;
              }

              /* TABLET */
              @media (max-width: 900px) {
                .footer-container {
                  grid-template-columns: repeat(2, 1fr);
                }
              }

              /* MOBILE */
              @media (max-width: 600px) {
                .footer-container {
                  grid-template-columns: 1fr;
                  text-align: center;
                }

                .footer-col-contact {
                  align-items: center;
                  max-width: 100%;
                }

                .contact-itemf {
                  justify-content: center;
                  text-align: left;
                }

                .social-icons {
                  justify-content: center;
                }
              }
      `}</style>
    </footer>
  );
}
